import { render, staticRenderFns } from "./reportsPDF.vue?vue&type=template&id=0446c606&scoped=true"
import script from "./reportsPDF.vue?vue&type=script&lang=js"
export * from "./reportsPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0446c606",
  null
  
)

export default component.exports